import { render, staticRenderFns } from "./VideoGeneratorNew.vue?vue&type=template&id=0b86d180&scoped=true"
import script from "./VideoGeneratorNew.vue?vue&type=script&lang=js"
export * from "./VideoGeneratorNew.vue?vue&type=script&lang=js"
import style0 from "./VideoGeneratorNew.vue?vue&type=style&index=0&id=0b86d180&prod&scoped=true&lang=css"
import style1 from "./VideoGeneratorNew.vue?vue&type=style&index=1&id=0b86d180&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86d180",
  null
  
)

export default component.exports